export default __webpack_public_path__ + "static/media/intrucciones_juego01.43388c68.png";